/* HIGHCOOL site-wide contact click tracking.
   Fires `hc_contact_click` for mailto: and WhatsApp (wa.me / api.whatsapp.com) links.
   Safe to load on every page and alongside hc-quote-form.js (binds once). */
(function () {
  'use strict';
  if (window.__hcContactTracking) return;
  window.__hcContactTracking = true;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var method = null;
    if (/^mailto:/i.test(href)) method = 'email';
    else if (/(^https?:\/\/)?(api\.)?wa\.me\//i.test(href) || /whatsapp\.com\/send/i.test(href)) method = 'whatsapp';
    if (!method) return;
    var data = {
      method: method,
      link_url: href.split('?')[0],
      link_text: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
      page_path: window.location.pathname
    };
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'hc_contact_click', method: data.method, link_url: data.link_url, link_text: data.link_text, page_path: data.page_path });
      if (window.HCInquiry) window.HCInquiry.contact(method);
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('hc_contact_click', data);
    } catch (err) {}
  }, true);
})();
